import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import AllPlans from "./routes/AllPlans";
import Types from "./routes/Types";

export default store => ({
  path: "student-plans",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "student-plans" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [AllPlans(store), Types(store)],
});
